import { render, staticRenderFns } from "./AttachmentButton.vue?vue&type=template&id=227c02a2"
import script from "./AttachmentButton.vue?vue&type=script&lang=js"
export * from "./AttachmentButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports